// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"879e3a72","977":"b656bed1"}[chunkId] + ".chunk.js";
};